var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Input } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useCallback, useEffect, useState, useRef } from 'react';
import { useEventComposerGlobalContext } from '../composers/EventComposerGlobalContext';
import { isTitleMissing } from '../utils/composerIssues';
export var TitleInput = function (_a) {
    var isRequestOnlyEvent = _a.isRequestOnlyEvent;
    var t = useTranslation('meetingRooms').t;
    var _b = useFormContext(), setValue = _b.setValue, getValues = _b.getValues;
    var hasAttemptedSubmit = useEventComposerGlobalContext().hasAttemptedSubmit;
    var _c = __read(useState(function () { return getValues('title') || ''; }), 2), title = _c[0], setTitle = _c[1];
    var debounceRef = useRef(null);
    var commitTitle = useCallback(function (nextTitle) {
        var current = getValues('title') || '';
        // Skip no-op commits (e.g. autoFocus → blur on open) so we don't mark
        // the form dirty when the value is unchanged.
        if (nextTitle === current) {
            return;
        }
        setValue('title', nextTitle, {
            shouldDirty: true,
            shouldValidate: false,
        });
    }, [getValues, setValue]);
    var handleEventTitle = useCallback(function (newTitle) {
        setTitle(newTitle);
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(function () {
            commitTitle(newTitle);
        }, 300);
    }, [commitTitle]);
    // Blur fires before the footer button's click, so committing the pending
    // value here guarantees Save validates against what the user actually typed
    // rather than a value still sitting in the debounce window.
    var flushTitle = useCallback(function () {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
            debounceRef.current = null;
        }
        commitTitle(title);
    }, [commitTitle, title]);
    useEffect(function () {
        return function () {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }
        };
    }, []);
    var showTitleRequiredError = hasAttemptedSubmit &&
        isTitleMissing({ isSpaceRequestOnlyEvent: isRequestOnlyEvent, title: title });
    return (_jsx(Form.Item, { label: t('create_event.title_label'), required: isRequestOnlyEvent, style: { marginBottom: 0 }, validateStatus: showTitleRequiredError ? 'error' : undefined, help: showTitleRequiredError ? t('create_event.title_required') : undefined, children: _jsx(Input, { autoFocus: true, type: "text", value: title, onChange: function (e) { return handleEventTitle(e.target.value); }, onBlur: flushTitle, placeholder: t('create_event.add_title') }) }));
};
